import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js/instance/sort';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js/instance/filter';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import _Object$keys from '@babel/runtime-corejs3/core-js/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js/object/get-own-property-symbols';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js/object/get-own-property-descriptors';
import React__default from 'react';

var _excluded = ["emote"],
    _excluded2 = ["emote"],
    _excluded3 = ["emote"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var createEmotePicker = function createEmotePicker(EmoteIcon) {
  return function (props) {
    var _context, _context2;

    // order 不存在或者为 0 的表情需要隐藏
    var sortedEmotes = _sortInstanceProperty(_context = _filterInstanceProperty(_context2 = props.emotes).call(_context2, function (_ref) {
      var order = _ref.order;
      return order && order !== 0;
    })).call(_context, function (a, b) {
      return a.order - b.order;
    });

    var handleClickEmote = function handleClickEmote(emote) {
      var _props$onSelect;

      (_props$onSelect = props.onSelect) === null || _props$onSelect === void 0 ? void 0 : _props$onSelect.call(props, emote);
    };

    return /*#__PURE__*/React__default.createElement("div", {
      className: "emotes-picker"
    }, _mapInstanceProperty(sortedEmotes).call(sortedEmotes, function (emote) {
      return /*#__PURE__*/React__default.createElement(EmoteIcon, {
        key: emote.text,
        emote: emote,
        onClick: function onClick() {
          handleClickEmote(emote);
        }
      });
    }));
  };
};

var SmallEmoteIcon = function SmallEmoteIcon(_ref2) {
  var emote = _ref2.emote,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React__default.createElement("img", _objectSpread({
    key: emote.text,
    className: "emote small",
    src: emote.image_url,
    alt: emote.text,
    title: emote.text
  }, rest));
};

var SmallEmotesPicker = createEmotePicker(SmallEmoteIcon);

var BigEmoteIcon = function BigEmoteIcon(_ref3) {
  var emote = _ref3.emote,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/React__default.createElement("img", _objectSpread({
    key: emote.text,
    className: "emote big",
    src: emote.image_url,
    alt: emote.text,
    title: emote.text
  }, rest));
};

var BigEmotesPicker = createEmotePicker(BigEmoteIcon);

var TextEmotesIcon = function TextEmotesIcon(_ref4) {
  var emote = _ref4.emote,
      rest = _objectWithoutProperties(_ref4, _excluded3);

  return /*#__PURE__*/React__default.createElement("div", _objectSpread({
    key: emote.text,
    className: "emote text"
  }, rest), emote.text);
};

var TextEmotesPicker = createEmotePicker(TextEmotesIcon);

export { BigEmotesPicker, SmallEmotesPicker, TextEmotesPicker };
